// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* UpgradeModal - Non-dismissible full-screen modal */

.upgrade-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
}

.upgrade-modal-card {
  background: #212121;
  border: 1px solid #333;
  border-radius: 16px;
  padding: 48px 40px;
  max-width: 480px;
  width: 100%;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
}

.upgrade-modal-icon {
  font-size: 64px;
  margin-bottom: 24px;
  line-height: 1;
}

.upgrade-modal-title {
  color: #fdfdfd;
  font-size: 32px;
  font-weight: 700;
  margin: 0 0 12px 0;
}

.upgrade-modal-founder-intro {
  color: #aeb9cc;
  font-size: 18px;
  margin: 0 0 24px 0;
  font-style: italic;
}

.upgrade-modal-feature {
  margin-bottom: 32px;
}

.upgrade-modal-feature-name {
  display: block;
  color: #218aff;
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 4px;
}

.upgrade-modal-coming-soon {
  display: block;
  color: #aeb9cc;
  font-size: 18px;
}

.upgrade-modal-message {
  margin-bottom: 32px;
}

.upgrade-modal-message p {
  color: #aeb9cc;
  font-size: 16px;
  line-height: 1.6;
  margin: 0 0 16px 0;
}

.upgrade-modal-message-secondary {
  color: #888 !important;
  font-style: italic;
}

.upgrade-modal-button {
  display: inline-block;
  padding: 16px 40px;
  background: #218aff;
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s ease;
}

.upgrade-modal-button:hover {
  background: #1a7aef;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(33, 138, 255, 0.3);
}

.upgrade-modal-button:active {
  transform: translateY(0);
}

.upgrade-modal-buttons {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
}

.upgrade-modal-button-secondary {
  display: inline-block;
  padding: 12px 32px;
  background: transparent;
  color: #aeb9cc;
  font-size: 16px;
  font-weight: 500;
  border: 1px solid #444;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.upgrade-modal-button-secondary:hover {
  background: #333;
  color: #fdfdfd;
  border-color: #555;
}

.upgrade-modal-button-secondary:active {
  transform: translateY(0);
}

/* Responsive adjustments */
@media (max-width: 540px) {
  .upgrade-modal-card {
    padding: 32px 24px;
  }

  .upgrade-modal-icon {
    font-size: 48px;
  }

  .upgrade-modal-title {
    font-size: 24px;
  }

  .upgrade-modal-feature-name {
    font-size: 20px;
  }

  .upgrade-modal-coming-soon {
    font-size: 16px;
  }

  .upgrade-modal-message p {
    font-size: 14px;
  }

  .upgrade-modal-button {
    padding: 14px 32px;
    font-size: 16px;
  }

  .upgrade-modal-founder-intro {
    font-size: 16px;
  }

  .upgrade-modal-button-secondary {
    padding: 10px 24px;
    font-size: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/UpgradeModal.css"],"names":[],"mappings":"AAAA,qDAAqD;;AAErD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,2BAA2B;AAC3B;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF","sourcesContent":["/* UpgradeModal - Non-dismissible full-screen modal */\n\n.upgrade-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.9);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  padding: 20px;\n}\n\n.upgrade-modal-card {\n  background: #212121;\n  border: 1px solid #333;\n  border-radius: 16px;\n  padding: 48px 40px;\n  max-width: 480px;\n  width: 100%;\n  text-align: center;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);\n}\n\n.upgrade-modal-icon {\n  font-size: 64px;\n  margin-bottom: 24px;\n  line-height: 1;\n}\n\n.upgrade-modal-title {\n  color: #fdfdfd;\n  font-size: 32px;\n  font-weight: 700;\n  margin: 0 0 12px 0;\n}\n\n.upgrade-modal-founder-intro {\n  color: #aeb9cc;\n  font-size: 18px;\n  margin: 0 0 24px 0;\n  font-style: italic;\n}\n\n.upgrade-modal-feature {\n  margin-bottom: 32px;\n}\n\n.upgrade-modal-feature-name {\n  display: block;\n  color: #218aff;\n  font-size: 24px;\n  font-weight: 600;\n  margin-bottom: 4px;\n}\n\n.upgrade-modal-coming-soon {\n  display: block;\n  color: #aeb9cc;\n  font-size: 18px;\n}\n\n.upgrade-modal-message {\n  margin-bottom: 32px;\n}\n\n.upgrade-modal-message p {\n  color: #aeb9cc;\n  font-size: 16px;\n  line-height: 1.6;\n  margin: 0 0 16px 0;\n}\n\n.upgrade-modal-message-secondary {\n  color: #888 !important;\n  font-style: italic;\n}\n\n.upgrade-modal-button {\n  display: inline-block;\n  padding: 16px 40px;\n  background: #218aff;\n  color: #fff;\n  font-size: 18px;\n  font-weight: 600;\n  border: none;\n  border-radius: 8px;\n  text-decoration: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.upgrade-modal-button:hover {\n  background: #1a7aef;\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(33, 138, 255, 0.3);\n}\n\n.upgrade-modal-button:active {\n  transform: translateY(0);\n}\n\n.upgrade-modal-buttons {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  align-items: center;\n}\n\n.upgrade-modal-button-secondary {\n  display: inline-block;\n  padding: 12px 32px;\n  background: transparent;\n  color: #aeb9cc;\n  font-size: 16px;\n  font-weight: 500;\n  border: 1px solid #444;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.upgrade-modal-button-secondary:hover {\n  background: #333;\n  color: #fdfdfd;\n  border-color: #555;\n}\n\n.upgrade-modal-button-secondary:active {\n  transform: translateY(0);\n}\n\n/* Responsive adjustments */\n@media (max-width: 540px) {\n  .upgrade-modal-card {\n    padding: 32px 24px;\n  }\n\n  .upgrade-modal-icon {\n    font-size: 48px;\n  }\n\n  .upgrade-modal-title {\n    font-size: 24px;\n  }\n\n  .upgrade-modal-feature-name {\n    font-size: 20px;\n  }\n\n  .upgrade-modal-coming-soon {\n    font-size: 16px;\n  }\n\n  .upgrade-modal-message p {\n    font-size: 14px;\n  }\n\n  .upgrade-modal-button {\n    padding: 14px 32px;\n    font-size: 16px;\n  }\n\n  .upgrade-modal-founder-intro {\n    font-size: 16px;\n  }\n\n  .upgrade-modal-button-secondary {\n    padding: 10px 24px;\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
